var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.dropdownsWithValues),function(dropdown){return _c('Dropdown',{key:dropdown.name,attrs:{"options":dropdown.values},on:{"input":function($event){return _vm.$emit('input', [dropdown.name, $event])}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }